import { FillInputByNameInstruction } from '../FillInputByNameInstruction'

export class FirstnameInstruction extends FillInputByNameInstruction {
  constructor ({ waitForNoLoaders, value }) {
    super({
      name: 'Firstname',
      waitForNoLoaders,
      inputName: 'firstname',
      value

    })
  }

  setDefaultValue (params) {
    this.value = params.userInformation.names.split(' ')[0]
  }
}
